const SPECS = [
  { k: "Instrument", v: "XAUUSD (gold)" },
  { k: "Platforms", v: "MetaTrader 4 and 5" },
  { k: "Order handling", v: "Basket, not single trades" },
  { k: "Risk controls", v: "Lot cap, equity guard, spread filter" },
  { k: "Daily target", v: "Configurable, then stops new cycles" },
  { k: "Entry pause", v: "Rollover and thin liquidity hours" },
  { k: "Account types", v: "Cent and standard" },
  { k: "Hosting", v: "Your own terminal or VPS" },
];

/** Factual spec panel. Deliberately not a chart: we do not show performance art. */
export const HeroVisual = () => (
  <div className="w-full" data-testid="hero-visual">
    <div
      className="rounded-xl"
      style={{
        background: "#0a1230",
        border: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      <div
        className="flex items-center justify-between px-5 py-4"
        style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}
      >
        <p className="text-sm font-bold text-white">What you are actually running</p>
        <span
          className="font-mono-gm text-[11px]"
          style={{ color: "var(--gm-muted-2)" }}
        >
          v4.2.3
        </span>
      </div>

      <dl className="divide-y" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
        {SPECS.map((s) => (
          <div
            key={s.k}
            className="flex items-baseline justify-between gap-4 px-5 py-3"
            style={{ borderColor: "rgba(255,255,255,0.06)" }}
          >
            <dt className="text-xs" style={{ color: "var(--gm-muted-2)" }}>
              {s.k}
            </dt>
            <dd className="text-right text-xs font-semibold text-white">{s.v}</dd>
          </div>
        ))}
      </dl>
    </div>

    <p className="mt-3 text-[11px]" style={{ color: "var(--gm-muted-2)" }}>
      No performance chart here on purpose. Results depend on your settings, your
      broker and the market, so we show you the mechanics instead.
    </p>
  </div>
);
